import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Btn, H4, Spinner } from '../../../AbstractElements';
import { Card, CardBody, Col, Table, Form, FormGroup, Label, Row, Modal, Button, CardHeader } from 'reactstrap';
import axios from 'axios';
import config from '../../../config';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import Papa from 'papaparse';
import configDB from '../../../Config/ThemeConfig';

const MONTH_NAMES = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

// Older API builds return only the month name, so fall back to resolving the
// month number from it instead of sending an undefined `month`.
const resolveMonthNumber = (item) => {
    if (!item) return null;
    if (item.month_number) return Number(item.month_number);
    const index = MONTH_NAMES.indexOf(item.month);
    return index === -1 ? null : index + 1;
};

const HomeView = () => {

    const token = localStorage.getItem("sessiontoken");
    const tenant_id = localStorage.getItem("tenantId");
    const currentYear = new Date().getFullYear();
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const [type, setType] = useState('daily')
    const [email, setEmail] = useState('');
    const [apiKey, setApiKey] = useState('');
    const [concessionaireId, setConcessionaireId] = useState('');
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedTenantId, setSelectedTenantId] = useState('');
    const [selectedStoreName, setSelectedStoreName] = useState('');
    const [selectedTcode, setSelectedTcode] = useState('');
    const [selectedUnitCode, setSelectedUnitCode] = useState('');
    const [selectedConcessionaireCode, setSelectedConcessionaireCode] = useState('');
    const [selectedMallCode, setSelectedMallCode] = useState('');
    const [tenantLiveDate, setTenantLiveDate] = useState('');
    const [tenantLiveDateObj, setTenantLiveDateObj] = useState('');
    const [stores, setStores] = useState([]);
    const [deliveryPartners, setDeliveryPartners] = useState([]);
    const [manualFlag, setManualFlag] = useState(false);
    const [monthlyData, setMonthlyData] = useState([]);
    const [dailyData, setDailyData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    // Tenant audit daily-sales upload (for NOT_MATCHED months)
    const login_id = localStorage.getItem("loginId");
    const auditFileRef = useRef();
    const [isAuditModalOpen, setIsAuditModalOpen] = useState(false);
    const [selectedAuditMonth, setSelectedAuditMonth] = useState(null);
    const [auditFile, setAuditFile] = useState(null);
    const [auditError, setAuditError] = useState('');
    const [auditRemarks, setAuditRemarks] = useState('');
    const [isAuditUploading, setIsAuditUploading] = useState(false);

    const primary = localStorage.getItem('default_color') || configDB.data.color.primary_color;
    // const secondary = localStorage.getItem('secondary_color') || configDB.data.color.secondary_color;

    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    useEffect(() => {
        axios.get(`${config.hostname}/tenant/${tenant_id}`, configheader)
            .then((response) => {
                setEmail(response.data.tenant_email_id)
                setConcessionaireId(response.data.tenant_concessionaire_id._id)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [])

    useEffect(() => {
        if (email !== '' && concessionaireId !== '') {
            const data = {
                email_id: email,
                concessionaire_id: concessionaireId
            }
            axios.post(`${config.hostname}/tenant/gettenantsbyemailid`, data, configheader)
                .then((response) => {
                    setStores(response.data)
                })
                .catch((error) => {
                    console.log(error);
                });
        }

    }, [email, concessionaireId]);

    const getMonthlySales = () => {
        const data = {
            tenant_id: selectedTenantId,
            year: selectedYear
        }
        axios.post(`${config.hostname}/tenanthome/getmonthlysales`, data, configheader)
            .then((response) => {
                setMonthlyData(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }

    useEffect(() => {
        getMonthlySales();
    }, [selectedYear, selectedTenantId])

    const getDailySales = () => {
        if (selectedTenantId !== '' && selectedMonth !== '' && selectedYear !== '') {
            const data = {
                tenant_id: selectedTenantId,
                month: selectedMonth,
                year: selectedYear
            }
            axios.post(`${config.hostname}/tenanthome/getdailysales`, data, configheader)
                .then((response) => {
                    setDailyData(response.data)
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    const getDeliveryPartner = (tenantId) => {
        setDeliveryPartners([])
        axios.post(`${config.hostname}/tenantdeliverypartner/getdeliverypartner`, { tenant_id: tenantId }, configheader)
            .then((response) => {
                const deliveryPartnerNames = response.data.map(item => item.delivery_partner_id.delivery_partner_name)
                // .filter(name => name !== "Dine In");
                setDeliveryPartners(deliveryPartnerNames);

            })
            .catch((error) => {
                console.log(error);
            });
    }
    useEffect(() => {
        getDailySales();
    }, [selectedYear, selectedMonth, selectedTenantId])

    const handleTypeChange = (e) => {
        setType(e.target.value)
        // setMonthlyData([]);
        setSelectedMonth('')
        setDailyData([])
    }

    const handleStoreChange = (e) => {
        const storeId = e.target.value
        setSelectedTenantId(storeId)
        if (storeId !== '') {
            const manualFlagEnabled = stores.find(store => store._id === storeId).tenant_manual_flag;
            setManualFlag(manualFlagEnabled)
            const storeName = stores.find(store => store._id === storeId).tenant_store_name;
            setSelectedStoreName(storeName)
            const tcode = stores.find(store => store._id === storeId).tenant_code;
            setSelectedTcode(tcode)
            const unitCode = stores.find(store => store._id === storeId).tenant_unit_code;
            setSelectedUnitCode(unitCode)
            const concessionaireCode = stores.find(store => store._id === storeId).tenant_concessionaire_code;
            setSelectedConcessionaireCode(concessionaireCode)
            const mallCode = stores.find(store => store._id === storeId).tenant_mall_code;
            setSelectedMallCode(mallCode)
            const apikey = stores.find(store => store._id === storeId).tenant_api_key;
            setApiKey(apikey)
            const livedate = stores.find(store => store._id === storeId).tenant_live_date;
            setTenantLiveDate(livedate);
            const liveDateObj = new Date(livedate);
            setTenantLiveDateObj(liveDateObj)
            getDeliveryPartner(storeId);
        }
    }

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value)
    }

    const handleMonthChange = (e) => {
        setSelectedMonth(e.target.value)
    }

    const handleUpdateClick = (transaction) => {
        setSelectedTransaction(transaction)
        setIsModalOpen(true); // Show modal
    };

    // Function to handle modal close
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    /* -------- Tenant audit daily-sales upload -------- */

    const handleTemplateDownload = () => {
        const csvContent = `date,transaction_count,net_sales`;
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', 'daily_sales_template.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleMarkMatched = (item) => {
        const monthNumber = resolveMonthNumber(item);
        if (!monthNumber) {
            toast.error('Missing month reference for this row');
            return;
        }
        const data = {
            tenant_id: selectedTenantId,
            month: monthNumber,
            year: selectedYear,
            login_id
        };
        axios.post(`${config.hostname}/tenantaudit/markmatched`, data, configheader)
            .then(() => {
                toast.success('Marked as matched');
                getMonthlySales();
            })
            .catch((error) => {
                toast.error(error.response?.data?.message || 'Failed to update audit status');
                console.log(error);
            });
    };

    const handleAuditUploadClick = (item) => {
        setSelectedAuditMonth(item);
        setAuditFile(null);
        setAuditError('');
        setAuditRemarks('');
        setIsAuditModalOpen(true);
    };

    const toggleAuditModal = () => {
        setIsAuditModalOpen(!isAuditModalOpen);
    };

    const handleAuditFileChange = (f) => {
        if (!f) return;
        if (!f.name.match(/\.csv$/i)) {
            setAuditError('Only .csv files are supported.');
            return;
        }
        setAuditError('');
        setAuditFile(f);
    };

    const handleAuditUpload = () => {
        if (!auditFile) {
            setAuditError('Please select a file before uploading.');
            return;
        }
        const auditMonthNumber = resolveMonthNumber(selectedAuditMonth);
        if (!auditMonthNumber) {
            setAuditError('Missing month reference for this upload.');
            return;
        }
        if (!auditRemarks.trim()) {
            setAuditError('Discrepancy remarks are required.');
            return;
        }

        setAuditError('');

        Papa.parse(auditFile, {
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                try {
                    const rows = results.data;
                    if (!rows || rows.length === 0) {
                        setAuditError('Uploaded file is empty.');
                        return;
                    }

                    const REQUIRED_COLUMNS = ['date', 'transaction_count', 'net_sales'];
                    const NUMBER_COLUMNS = ['transaction_count', 'net_sales'];
                    const headers = Object.keys(rows[0] || {});

                    const missingColumns = REQUIRED_COLUMNS.filter(col => !headers.includes(col));
                    if (missingColumns.length > 0) {
                        setAuditError('Invalid file structure. Please use the provided template.');
                        return;
                    }

                    const hasBlank = rows.some(row =>
                        REQUIRED_COLUMNS.some(col =>
                            row[col] === undefined || row[col] === null || String(row[col]).trim() === ''
                        )
                    );
                    if (hasBlank) {
                        setAuditError('Uploaded file contains blank values. Please ensure all fields are filled.');
                        return;
                    }

                    const invalidNumber = rows.some(row =>
                        NUMBER_COLUMNS.some(col => isNaN(Number(row[col])))
                    );
                    if (invalidNumber) {
                        setAuditError('transaction_count and net_sales must contain valid numbers only.');
                        return;
                    }

                    const formattedData = rows.map(r => ({
                        date: String(r.date).trim(),
                        transaction_count: Number(r.transaction_count),
                        net_sales: Number(r.net_sales)
                    }));

                    setIsAuditUploading(true);
                    axios.post(
                        `${config.hostname}/tenantaudit/uploaddailyaudit`,
                        {
                            tenant_id: selectedTenantId,
                            month: auditMonthNumber,
                            year: selectedYear,
                            login_id,
                            discrepancy_remarks: auditRemarks.trim(),
                            data: formattedData
                        },
                        configheader
                    )
                        .then(() => {
                            toast.success('Daily sales uploaded successfully');
                            setIsAuditUploading(false);
                            setIsAuditModalOpen(false);
                            getMonthlySales();
                        })
                        .catch((err) => {
                            setIsAuditUploading(false);
                            setAuditError(err.response?.data?.message || 'Upload failed.');
                        });

                } catch {
                    setAuditError('Failed to process file.');
                }
            },
            error: () => {
                setAuditError('CSV parsing failed.');
            }
        });
    };

    const updateSales = async (e) => {
        e.preventDefault();
        let isValid = true;
        let errorMessage = "";

        // Check the main transaction count and total sales
        const mainTransactionCount = Number(selectedTransaction.transaction_count) || 0;
        const mainTotalSales = Number(selectedTransaction.total_sales) || 0;

        const grossAmount = Number(selectedTransaction.gross_sales);
        const taxAmount = Number(selectedTransaction.tax_amount);
        const discountAmount = Number(selectedTransaction.discount_amount);
        const returnAmount = Number(selectedTransaction.return_amount);

        // const calculatedNetSales = grossAmount - taxAmount - discountAmount - returnAmount

        // if (mainTotalSales !== calculatedNetSales) {
        //     isValid = false;
        //     errorMessage = "Amount mismatch";
        // }

        if (mainTransactionCount === 0 && mainTotalSales !== 0) {
            isValid = false;
            errorMessage = "If the transaction count is 0, the net sales must be 0.";
        }

        // Loop through the delivery partners to check the counts and corresponding sales
        deliveryPartners.forEach((partner) => {
            const partnerKey = partner.toLowerCase().replace(/ /g, '_');
            const countKey = `${partnerKey}_count`;
            const salesKey = `${partnerKey}_sales`;

            const count = Number(selectedTransaction[countKey]) || 0;
            const sales = Number(selectedTransaction[salesKey]) || 0;

            if (count === 0 && sales !== 0) {
                isValid = false;
                errorMessage = `For ${partner.replace('_', ' ')}, if the count is 0, the sales must be 0.`;
            }
        });

        if (!isValid) {
            // Show an error message if validation fails
            toast.warning(errorMessage);
            return; // Stop the function if validation fails
        }

        const [year, month, day] = selectedTransaction.transaction_date.split('-'); // Split by '-'
        const formattedDate = new Date(`${year}-${month}-${day}T00:00:00Z`).toISOString();


        const authorization = {
            headers: {
                'x-api-key': apiKey
            }
        };

        if (deliveryPartners.length <= 0) {
            const data = {
                concessionaire_code: selectedConcessionaireCode,
                tenant_code: selectedTcode,
                outlet_code: selectedUnitCode,
                mall_code: selectedMallCode,
                transaction_date: formattedDate,
                transaction_count: selectedTransaction.transaction_count,
                net_sales: selectedTransaction.total_sales,
                // gross_amount: grossAmount,
                // tax_amount: taxAmount,
                // discount_amount: discountAmount,
                // return_amount: returnAmount,
            }

            if (selectedTransaction.gross_sales !== null &&
                selectedTransaction.gross_sales !== '' &&
                !Number.isNaN(grossAmount)) {
                data.gross_amount = grossAmount;
            }

            if (selectedTransaction.tax_amount !== null &&
                selectedTransaction.tax_amount !== '' &&
                !Number.isNaN(taxAmount)) {
                data.tax_amount = taxAmount;
            }

            if (selectedTransaction.discount_amount !== null &&
                selectedTransaction.discount_amount !== '' &&
                !Number.isNaN(discountAmount)) {
                data.discount_amount = discountAmount;
            }

            if (selectedTransaction.return_amount !== null &&
                selectedTransaction.return_amount !== '' &&
                !Number.isNaN(returnAmount)) {
                data.return_amount = returnAmount;
            }

            setIsLoading(true)
            axios.post(`${config.hostname}/salesTransactions`, data, authorization)
                .then(() => {
                    toast.success('Data updated successfully')
                    toggleModal();
                    getDailySales();
                    setIsLoading(false)
                })
                .catch((error) => {
                    toast.error('Error')
                    console.log(error);
                    setIsLoading(false)
                });
        }

        if (deliveryPartners.length > 0) {
            const fbData = {
                concessionaire_code: selectedConcessionaireCode,
                tenant_code: selectedTcode,
                outlet_code: selectedUnitCode,
                mall_code: selectedMallCode,
                transaction_date: formattedDate,
                // gross_amount: grossAmount,
                // tax_amount: taxAmount,
                // discount_amount: discountAmount,
                // return_amount: returnAmount,
            }

            if (selectedTransaction.gross_sales !== null &&
                selectedTransaction.gross_sales !== '' &&
                !Number.isNaN(grossAmount)) {
                fbData.gross_amount = grossAmount;
            }

            if (selectedTransaction.tax_amount !== null &&
                selectedTransaction.tax_amount !== '' &&
                !Number.isNaN(taxAmount)) {
                fbData.tax_amount = taxAmount;
            }

            if (selectedTransaction.discount_amount !== null &&
                selectedTransaction.discount_amount !== '' &&
                !Number.isNaN(discountAmount)) {
                fbData.discount_amount = discountAmount;
            }

            if (selectedTransaction.return_amount !== null &&
                selectedTransaction.return_amount !== '' &&
                !Number.isNaN(returnAmount)) {
                fbData.return_amount = returnAmount;
            }
            deliveryPartners.forEach((partner) => {
                const partnerKey = partner.toLowerCase().replace(/ /g, '_');
                fbData[`${partnerKey}_sales`] = selectedTransaction[`${partnerKey}_sales`] || 0;
                fbData[`${partnerKey}_count`] = selectedTransaction[`${partnerKey}_count`] || 0;
            });

            setIsLoading(true)
            axios.post(`${config.hostname}/deliverypartnersales`, fbData, authorization)
                .then(() => {
                    toast.success('Data updated successfully')
                    toggleModal();
                    getDailySales();
                    setIsLoading(false)
                })
                .catch((error) => {
                    toast.error('Error')
                    console.log(error);
                    setIsLoading(false)
                });
        }


    }

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '18px', // Make the font bigger
        marginBottom: '20px',
    };

    const thStyle = {
        backgroundColor: primary,
        color: 'white',
        padding: '12px',
        textAlign: 'left',
        fontWeight: 'bold',
    };

    const tdStyle = {
        padding: '12px',
        border: '1px solid #ddd',
    };

    const trStyle = {
        backgroundColor: '#f2f2f2',
    };


    const normalize = (p) => p.replace(/_/g, "").toLowerCase();

    // Make a new array with DineIn first
    const deliveryPartnersOrdered = [
        // 1) DineIn (any of: "DineIn", "DINEIN", "dine_in", etc.)
        ...deliveryPartners.filter((p) => normalize(p) === "dinein"),
        // 2) All others, in original order
        ...deliveryPartners.filter((p) => normalize(p) !== "dinein"),
    ];



    return (
        <Fragment>
            <Card>
                <CardHeader>
                    <Row>
                        <Col>
                            <FormGroup className="mb-3">
                                <Label htmlFor="property_id">Type</Label>
                                <select name="property_id" id="property_id" className="form-control" value={type}
                                    onChange={handleTypeChange}>
                                    <option value="">Select Type</option>
                                    <option value="daily">Daily</option>
                                    <option value="monthly">Monthly</option>
                                </select>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup className="mb-3">
                                <Label htmlFor="property_id">Store</Label>
                                <select name="property_id" id="property_id" className="form-control"
                                    onChange={handleStoreChange}>
                                    <option value="">Select Store</option>
                                    {stores.map(store => (
                                        <option key={store._id} value={store._id}>{`${store.tenant_store_name} - ${store.tenant_code} (${store.tenant_property_id?.property_name})`}</option>
                                    ))}
                                </select>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup className="mb-3">
                                <Label htmlFor="year">Year</Label>
                                <select name="year" id="year" className="form-control digits"
                                    onChange={handleYearChange}>
                                    <option value={currentYear}>{currentYear}</option>
                                    <option value={currentYear - 1}>{currentYear - 1}</option>
                                    <option value={currentYear - 2}>{currentYear - 2}</option>
                                </select>
                            </FormGroup>
                        </Col>
                        <Col>
                            {type === 'daily' && (
                                <FormGroup className="mb-3">
                                    <Label htmlFor="property_id">Month</Label>
                                    <select name="property_id" id="property_id" className="form-control" value={selectedMonth}
                                        onChange={handleMonthChange}>
                                        <option value="">Select Month</option>
                                        <option value="01">January</option>
                                        <option value="02">February</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>
                                </FormGroup>
                            )}
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <Col sm="12" lg="12" xl="12">
                        <div className="table-responsive" >
                            <Table style={tableStyle}>
                                <thead >
                                    <tr>
                                        <th style={thStyle} scope="col" >Store Name</th>
                                        <th style={thStyle} scope="col" >Tenant Code </th>
                                        <th style={thStyle} scope="col" >{type === 'monthly' ? 'Month' : 'Date'} </th>
                                        <th style={thStyle} scope="col">Transaction Count </th>
                                        <th style={thStyle} scope="col" >Sales </th>
                                        {deliveryPartners.length > 0 && deliveryPartnersOrdered.map((partner) => {
                                            const keyBase = partner.toLowerCase().replace(/ /g, '_');
                                            const partnerLabel = partner.replace(/_/g, ' ');
                                            return (
                                                <Fragment key={`head-${keyBase}`}>
                                                    <th style={thStyle} scope="col">{partnerLabel} Count </th>
                                                    <th style={thStyle} scope="col">{partnerLabel} Sales </th>
                                                </Fragment>
                                            );
                                        })}
                                        {type === 'monthly' && (
                                            <th style={thStyle} scope="col" > Audit Status </th>
                                        )}
                                        {(type === 'daily' && manualFlag) && (
                                            <th style={thStyle} scope="col" > Action </th>
                                        )}
                                    </tr>
                                </thead>
                                {type === 'monthly' && (
                                    <tbody >
                                        {monthlyData.map((item, index) => (
                                            <tr key={index}>
                                                <td style={tdStyle}>{item.tenant_name}</td>
                                                <td style={tdStyle}>{item.tenant_code}</td>
                                                <td style={tdStyle}>{item.month}</td>
                                                <td style={tdStyle}>{item.transaction_count}</td>
                                                <td style={tdStyle}>{item.total_sales.toFixed(2)}</td>
                                                {deliveryPartners.length > 0 && deliveryPartnersOrdered.map((partner) => {
                                                    const keyBase = partner.toLowerCase().replace(/ /g, '_');
                                                    const count = item[`${keyBase}_count`];
                                                    const sales = item[`${keyBase}_sales`];
                                                    return (
                                                        <Fragment key={`m-${index}-${keyBase}`}>
                                                            <td style={tdStyle}>{count !== undefined && count !== null && count !== '' ? count : ''}</td>
                                                            <td style={tdStyle}>{sales !== undefined && sales !== null && sales !== '' ? Number(sales).toFixed(2) : ''}</td>
                                                        </Fragment>
                                                    );
                                                })}
                                                <td style={tdStyle}>
                                                    {(() => {
                                                        const status = item.audit_status;
                                                        const isMatching = status === 'MATCHED' || status === 'RECONCILED';
                                                        const isNotMatching = status === 'NOT_MATCHED';
                                                        const locked = item.is_locked;

                                                        // Locked period -> read-only pill.
                                                        if (locked) {
                                                            const color = isMatching ? '#28a745' : (isNotMatching ? '#dc3545' : '#6c757d');
                                                            const label = isMatching ? 'Matching' : (isNotMatching ? 'Not Matching' : 'Pending');
                                                            return (
                                                                <span
                                                                    style={{
                                                                        display: 'inline-block',
                                                                        padding: '4px 12px',
                                                                        borderRadius: '12px',
                                                                        fontSize: '14px',
                                                                        fontWeight: 600,
                                                                        color: '#ffffff',
                                                                        backgroundColor: color,
                                                                    }}
                                                                >
                                                                    {label} (Locked)
                                                                </span>
                                                            );
                                                        }

                                                        // Segmented toggle: Matched | Not Matching.
                                                        const segBase = {
                                                            appearance: 'none',
                                                            outline: 'none',
                                                            border: '1px solid #d5d9e0',
                                                            minWidth: '104px',
                                                            padding: '7px 16px',
                                                            cursor: 'pointer',
                                                            fontSize: '13px',
                                                            fontWeight: 600,
                                                            lineHeight: 1,
                                                            whiteSpace: 'nowrap',
                                                            background: '#ffffff',
                                                            color: '#6b7280',
                                                            transition: 'all 0.15s ease',
                                                        };
                                                        return (
                                                            <div
                                                                style={{
                                                                    display: 'inline-flex',
                                                                    borderRadius: '999px',
                                                                    overflow: 'hidden',
                                                                    boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                                                                }}
                                                            >
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleMarkMatched(item)}
                                                                    style={{
                                                                        ...segBase,
                                                                        borderRight: 'none',
                                                                        ...(isMatching
                                                                            ? { background: '#28a745', color: '#ffffff', borderColor: '#28a745' }
                                                                            : {}),
                                                                    }}
                                                                >
                                                                    ✓ Matched
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleAuditUploadClick(item)}
                                                                    style={{
                                                                        ...segBase,
                                                                        ...(isNotMatching
                                                                            ? { background: '#dc3545', color: '#ffffff', borderColor: '#dc3545' }
                                                                            : {}),
                                                                    }}
                                                                >
                                                                    ✕ Not Matching
                                                                </button>
                                                            </div>
                                                        );
                                                    })()}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                )}

                                {type === 'daily' && (
                                    <tbody >
                                        {dailyData.map((item, index) => (
                                            <tr key={index}>
                                                <td style={tdStyle}>{item.tenant_name || selectedStoreName} </td>
                                                <td style={tdStyle}>{item.tenant_code || selectedTcode}</td>
                                                <td style={tdStyle}>{item.transaction_date}</td>
                                                <td style={tdStyle}>{item.transaction_count}</td>
                                                <td style={tdStyle}>{item.total_sales !== '' && item.total_sales.toFixed(2)}</td>
                                                {deliveryPartners.length > 0 && deliveryPartnersOrdered.map((partner) => {
                                                    const keyBase = partner.toLowerCase().replace(/ /g, '_');
                                                    const count = item[`${keyBase}_count`];
                                                    const sales = item[`${keyBase}_sales`];
                                                    return (
                                                        <Fragment key={`d-${index}-${keyBase}`}>
                                                            <td style={tdStyle}>{count !== undefined && count !== null && count !== '' ? count : ''}</td>
                                                            <td style={tdStyle}>{sales !== undefined && sales !== null && sales !== '' ? Number(sales).toFixed(2) : ''}</td>
                                                        </Fragment>
                                                    );
                                                })}
                                                {(type === 'daily' && manualFlag) && (
                                                    <td>

                                                        <button
                                                            style={{
                                                                marginLeft: '10px',
                                                                backgroundColor: ((item.transaction_count !== undefined && item.transaction_count !== null && item.transaction_count !== '' &&
                                                                    item.total_sales !== undefined && item.total_sales !== null && item.total_sales !== '') ||
                                                                    // new Date(item.transaction_date).setHours(0, 0, 0, 0) < tenantLiveDateObj.setHours(0, 0, 0, 0) ||
                                                                    new Date(item.transaction_date).setHours(0, 0, 0, 0) >= currentDate)
                                                                    ? 'grey'  // Grey when disabled
                                                                    : primary,
                                                                color: ((item.transaction_count !== undefined && item.transaction_count !== null && item.transaction_count !== '' &&
                                                                    item.total_sales !== undefined && item.total_sales !== null && item.total_sales !== '') ||
                                                                    // new Date(item.transaction_date).setHours(0, 0, 0, 0) < tenantLiveDateObj.setHours(0, 0, 0, 0) ||
                                                                    new Date(item.transaction_date).setHours(0, 0, 0, 0) >= currentDate)
                                                                    ? '#ffffff'
                                                                    : '#ffffff',
                                                                border: 'none',
                                                                padding: '5px 10px',
                                                                cursor: ((item.transaction_count !== undefined && item.transaction_count !== null && item.transaction_count !== '' &&
                                                                    item.total_sales !== undefined && item.total_sales !== null && item.total_sales !== '') ||
                                                                    // new Date(item.transaction_date).setHours(0, 0, 0, 0) < tenantLiveDateObj.setHours(0, 0, 0, 0) ||
                                                                    new Date(item.transaction_date).setHours(0, 0, 0, 0) >= currentDate)
                                                                    ? 'not-allowed'
                                                                    : 'pointer', // Not-allowed cursor when disabled
                                                                opacity: ((item.transaction_count !== undefined && item.transaction_count !== null && item.transaction_count !== '' &&
                                                                    item.total_sales !== undefined && item.total_sales !== null && item.total_sales !== '') ||
                                                                    // new Date(item.transaction_date).setHours(0, 0, 0, 0) < tenantLiveDateObj.setHours(0, 0, 0, 0) ||
                                                                    new Date(item.transaction_date).setHours(0, 0, 0, 0) >= currentDate)
                                                                    ? 0.6
                                                                    : 1, // Slightly transparent when disabled
                                                            }}
                                                            className="fa fa-pencil btn-sm"
                                                            type="button"

                                                            disabled={(item.transaction_count !== undefined && item.transaction_count !== null && item.transaction_count !== '' &&
                                                                item.total_sales !== undefined && item.total_sales !== null && item.total_sales !== '') ||
                                                                // new Date(item.transaction_date).setHours(0, 0, 0, 0) < tenantLiveDateObj.setHours(0, 0, 0, 0) ||    //disble dates before live date
                                                                new Date(item.transaction_date).setHours(0, 0, 0, 0) >= currentDate}
                                                            onClick={() => handleUpdateClick(item)}
                                                        >
                                                            Update
                                                        </button>


                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                )}
                            </Table>
                        </div>
                        {/* Modal */}
                        {selectedTransaction && (
                            <Modal isOpen={isModalOpen} toggle={toggleModal}>
                                <div className="modal-header">
                                    <h5 className="modal-title">Update Sales Data</h5>
                                    <button
                                        type="button"
                                        onClick={toggleModal}
                                        className="btn btn-light btn-sm"
                                        style={{
                                            borderRadius: '50%',
                                            width: '32px',
                                            height: '32px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '1.2rem',
                                            padding: 0,
                                            marginLeft: 'auto',
                                        }}
                                    >
                                        &times;
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Form className='theme-form' onSubmit={updateSales}>
                                        <div className="form-group">
                                            <label>Transaction Date:</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={selectedTransaction.transaction_date}
                                                disabled
                                            />
                                        </div>

                                        {deliveryPartners.length <= 0 && (
                                            <>
                                                <div className="form-group">
                                                    <label>Transaction Count</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        required
                                                        value={selectedTransaction.transaction_count}
                                                        onChange={(e) => {
                                                            setSelectedTransaction({
                                                                ...selectedTransaction,
                                                                transaction_count: e.target.value,
                                                            });
                                                        }}
                                                        onWheel={e => e.currentTarget.blur()}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Net Sales</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        required
                                                        value={selectedTransaction.total_sales}
                                                        onChange={(e) => {
                                                            setSelectedTransaction({
                                                                ...selectedTransaction,
                                                                total_sales: e.target.value,
                                                            });
                                                        }}
                                                        onWheel={e => e.currentTarget.blur()}
                                                    />
                                                </div>

                                            </>
                                        )}

                                        {/* {deliveryPartners.map((partner, index) => (
                                            <>
                                                <div className="form-group">
                                                    <label>{partner.replace('_', ' ')} Count</label>
                                                    <input
                                                        type="number"
                                                        required
                                                        className="form-control"
                                                        value={selectedTransaction[partner.toLowerCase().replace(/ /g, '_') + '_count'] || ''}
                                                        onChange={(e) => {
                                                            setSelectedTransaction({
                                                                ...selectedTransaction,
                                                                [partner.toLowerCase().replace(/ /g, '_') + '_count']: e.target.value,
                                                            });
                                                        }}
                                                        onWheel={e => e.currentTarget.blur()}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>{partner.replace('_', ' ')} Sales</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        required
                                                        value={selectedTransaction[partner.toLowerCase().replace(/ /g, '_') + '_sales'] || ''}
                                                        onChange={(e) => {
                                                            setSelectedTransaction({
                                                                ...selectedTransaction,
                                                                [partner.toLowerCase().replace(/ /g, '_') + '_sales']: e.target.value,
                                                            });
                                                        }}
                                                        onWheel={e => e.currentTarget.blur()}
                                                    />
                                                </div>
                                            </>

                                        ))} */}


                                        {deliveryPartners.length > 0 && (
                                            <div className="card mt-3">
                                                <div className="mt-2 mb-2" style={{ textAlign: 'left', justifyContent: 'flex-start' }}>
                                                    <strong>F&B Sales Split</strong>
                                                </div>

                                                <div className="card-body p-0">
                                                    <table className="table mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Delivery Partner</th>
                                                                <th className="text-center">Transaction Count</th>
                                                                <th className="text-center">Net Sales</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {deliveryPartnersOrdered.map((partner) => {
                                                                const keyBase = partner.toLowerCase().replace(/ /g, "_");
                                                                return (
                                                                    <tr key={keyBase}>
                                                                        <td>{partner.replace("_", " ")}</td>

                                                                        <td className="text-center" style={{ width: "160px" }}>
                                                                            <input
                                                                                type="number"
                                                                                required
                                                                                className="form-control form-control-sm text-end"
                                                                                value={
                                                                                    selectedTransaction[`${keyBase}_count`]
                                                                                }
                                                                                onChange={(e) =>
                                                                                    setSelectedTransaction({
                                                                                        ...selectedTransaction,
                                                                                        [`${keyBase}_count`]: e.target.value,
                                                                                    })
                                                                                }
                                                                                onWheel={(e) => e.currentTarget.blur()}
                                                                            />
                                                                        </td>

                                                                        <td className="text-center" style={{ width: "160px" }}>
                                                                            <input
                                                                                type="number"
                                                                                required
                                                                                className="form-control form-control-sm text-end"
                                                                                value={
                                                                                    selectedTransaction[`${keyBase}_sales`]
                                                                                }
                                                                                onChange={(e) =>
                                                                                    setSelectedTransaction({
                                                                                        ...selectedTransaction,
                                                                                        [`${keyBase}_sales`]: e.target.value,
                                                                                    })
                                                                                }
                                                                                onWheel={(e) => e.currentTarget.blur()}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                        {concessionaireId !== '68145733211db7ab0824a5db' && (
                                            <>
                                                <div className="form-group">
                                                    <label>Gross Sales</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        // required
                                                        value={selectedTransaction.gross_sales}
                                                        onChange={(e) => {
                                                            setSelectedTransaction({
                                                                ...selectedTransaction,
                                                                gross_sales: e.target.value,
                                                            });
                                                        }}
                                                        onWheel={e => e.currentTarget.blur()}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Tax Amount</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        // required
                                                        value={selectedTransaction.tax_amount}
                                                        onChange={(e) => {
                                                            setSelectedTransaction({
                                                                ...selectedTransaction,
                                                                tax_amount: e.target.value,
                                                            });
                                                        }}
                                                        onWheel={e => e.currentTarget.blur()}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Discount Amount</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        // required
                                                        value={selectedTransaction.discount_amount}
                                                        onChange={(e) => {
                                                            setSelectedTransaction({
                                                                ...selectedTransaction,
                                                                discount_amount: e.target.value,
                                                            });
                                                        }}
                                                        onWheel={e => e.currentTarget.blur()}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Return Amount</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        // required
                                                        value={selectedTransaction.return_amount}
                                                        onChange={(e) => {
                                                            setSelectedTransaction({
                                                                ...selectedTransaction,
                                                                return_amount: e.target.value,
                                                            });
                                                        }}
                                                        onWheel={e => e.currentTarget.blur()}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        <div className="modal-footer">
                                            <Button color="primary" type='submit'
                                                disabled={isLoading}
                                            >
                                                {isLoading ? 'Updating...' : 'Update Sales'}
                                            </Button>
                                            <Button color="secondary" onClick={toggleModal}>
                                                Close
                                            </Button>
                                        </div>
                                    </Form>
                                </div>

                            </Modal>
                        )}

                        {/* Tenant audit daily-sales upload modal */}
                        <Modal isOpen={isAuditModalOpen} toggle={toggleAuditModal}>
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Upload Daily Sales{selectedAuditMonth ? ` - ${selectedAuditMonth.month}` : ''}
                                </h5>
                                <button
                                    type="button"
                                    onClick={toggleAuditModal}
                                    className="btn btn-light btn-sm"
                                    style={{
                                        borderRadius: '50%',
                                        width: '32px',
                                        height: '32px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '1.2rem',
                                        padding: 0,
                                        marginLeft: 'auto',
                                    }}
                                >
                                    &times;
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mb-2">
                                    This month is <strong>Not Matching</strong>. Upload your daily sales
                                    (transaction count and net sales without tax) using the sample format.
                                </p>

                                <div className="mb-3">
                                    <Button color="link" className="p-0" onClick={handleTemplateDownload}>
                                        <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                                        Download sample format (.csv)
                                    </Button>
                                </div>

                                <div
                                    onClick={() => auditFileRef.current?.click()}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) => { e.preventDefault(); handleAuditFileChange(e.dataTransfer.files[0]); }}
                                    className="border rounded text-center p-4"
                                    style={{
                                        borderStyle: 'dashed',
                                        borderColor: auditFile ? primary : '#ced4da',
                                        background: auditFile ? 'rgba(115,102,255,0.05)' : '#f8f9fa',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {auditFile ? (
                                        <>
                                            <p className="mb-0 fw-bold" style={{ color: primary }}>{auditFile.name}</p>
                                            <small className="text-muted">{(auditFile.size / 1024).toFixed(1)} KB · Click to change</small>
                                        </>
                                    ) : (
                                        <>
                                            <div style={{ fontSize: 28, marginBottom: 8 }}>📂</div>
                                            <p className="mb-0 fw-bold">Drop your file here, or click to browse</p>
                                            <small className="text-muted">Supports .csv</small>
                                        </>
                                    )}
                                    <input ref={auditFileRef} type="file" accept=".csv" style={{ display: 'none' }}
                                        onChange={(e) => handleAuditFileChange(e.target.files[0])} />
                                </div>

                                <div className="form-group mt-3">
                                    <Label className="fw-bold">
                                        Discrepancy Remarks <span className="text-danger">*</span>
                                    </Label>
                                    <textarea
                                        className="form-control"
                                        rows={3}
                                        required
                                        placeholder="Explain the reason for the discrepancy"
                                        value={auditRemarks}
                                        onChange={(e) => setAuditRemarks(e.target.value)}
                                    />
                                </div>

                                {auditError && <small className="text-danger mt-1 d-block">{auditError}</small>}
                            </div>
                            <div className="modal-footer">
                                <Button color="primary" onClick={handleAuditUpload} disabled={isAuditUploading}>
                                    {isAuditUploading ? 'Uploading...' : 'Upload'}
                                </Button>
                                <Button color="secondary" onClick={toggleAuditModal}>
                                    Close
                                </Button>
                            </div>
                        </Modal>
                    </Col>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default HomeView